import { Badge } from '../catalyst/badge'
import type { AdminFertilizerRow, FertilizerProduct } from '../lib/types'
import { ListPage } from './list-page'
import { ReviewBadge } from './review'

export const CATEGORY_LABELS: Record<FertilizerProduct['category'], string> = {
  COMPLETE_NPK: 'Complete NPK',
  PARTIAL_NPK: 'Two of N, P, K',
  STRAIGHT_NITROGEN: 'Nitrogen',
  STRAIGHT_PHOSPHORUS: 'Phosphorus',
  STRAIGHT_POTASSIUM: 'Potassium',
  SECONDARY: 'Calcium, magnesium, sulphur',
  MICRONUTRIENT: 'Micronutrient',
  STARTER: 'Starter',
  BIOSTIMULANT: 'Biostimulant',
  HUMIC: 'Humic',
  OTHER: 'Other',
}

export function FertilizersPage() {
  return (
    <ListPage<AdminFertilizerRow>
      title="Fertilizers"
      description="The fertilizer catalogue, compiled from supplier websites. Open a product to check it against the supplier's page, fix it, and mark it reviewed."
      path="/admin/fertilizers"
      noun="fertilizers"
      rowHref={(p) => `/fertilizers/${p.id}`}
      filter={{
        param: 'review',
        label: 'Review state',
        initial: 'needs_review',
        options: [
          { value: '', label: 'All' },
          { value: 'needs_review', label: 'Needs review (incl. unreadable analysis)' },
          { value: 'unreviewed', label: 'Not yet reviewed' },
          { value: 'approved', label: 'Reviewed' },
          { value: 'rejected', label: 'Rejected' },
        ],
      }}
      columns={[
        { header: 'Name', primary: true, cell: (p) => p.name },
        { header: 'Supplier', cell: (p) => p.supplier },
        { header: 'Analysis', cell: (p) => p.analysisRaw || '—' },
        { header: 'Type', cell: (p) => CATEGORY_LABELS[p.category] },
        {
          header: 'Review',
          cell: (p) => (
            <span className="flex flex-wrap gap-1">
              <ReviewBadge status={p.reviewStatus} />
              {p.analysisStatus === 'NEEDS_REVIEW' && <Badge color="amber">Analysis unreadable</Badge>}
            </span>
          ),
        },
      ]}
    />
  )
}
